import { render, staticRenderFns } from "./o-radio-buttons.vue?vue&type=template&id=7b9c057a&scoped=true&"
import script from "./o-radio-buttons.vue?vue&type=script&lang=js&"
export * from "./o-radio-buttons.vue?vue&type=script&lang=js&"
import style0 from "./o-radio-buttons.vue?vue&type=style&index=0&id=7b9c057a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9c057a",
  null
  
)

export default component.exports